import React, { ReactNode } from 'react';
import styled from 'styled-components';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../context/ProductBuilder/machine';

type Props = {
  number: number;
  children: ReactNode;
};

const getWidth = ({ number }: { number: number }) =>
  number.toString().length * 1.5;

const getOffset = ({ number }: { number: number }) =>
  number.toString().length * 0.5;

const Circle = styled.span<Props>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${getWidth}em;
  height: ${getWidth}em;
  background-color: #3a3a3a;
  border-radius: 100px;
  color: white;
  position: absolute;
  bottom: -${getOffset}em;
  right: -${getOffset}em;
`;

export const CartNumber = () => {
  const [state] = useService(productBuilderMachine);
  const { cart } = state.context;
  const itemCount = cart && cart.items ? cart.items.length : 0;
  if (itemCount === 0) return null;
  return <Circle number={itemCount}>{itemCount}</Circle>;
};
